import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'OrganizationChannelConnectionsPage.LandingPage.Title',
    defaultMessage: 'Channel Connections'
  },
  header: {
    id: 'OrganizationChannelConnectionsPage.LandingPage.Header',
    defaultMessage: 'No channels connected'
  },
  subHeader: {
    id: 'OrganizationChannelConnectionsPage.LandingPage.SubHeader',
    defaultMessage: 'Extend Workgrid capabilities into 3rd party channels or place the digital assistant onto any site.'
  },
  createChannelConnectionButton: {
    id: 'OrganizationChannelConnectionsPage.LandingPage.CreateChannelConnection',
    defaultMessage: 'Add Connection'
  }
})
